import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';

var fteamSignupForm = function (classname, form) {
  const $form = $(form);
  const signUpApiUrl = $form.data('signup-url') || 'https://signup.freshteam.com/accounts';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  let userEmail = $form.find('.email-form').val();
  if (!userEmail) {
    userEmail = $form.find('.email-fteam').val();
  }
  const userFirstName = $form.find('.first-name-form').val() || null;
  const userLastName = $form.find('.last-name-form').val() || null;
  const userCompany = $form.find('.company-form').val() || null;
  const userPhoneNo = $form.find('.phone-form').val() || null;
  const emailHash = SiteUtilities.getShaHash(userEmail);
  const geoLocation = LocationUtilities.getGeoLocation();
  const country = geoLocation ? geoLocation.countryName : '';
  const remindEndPoint = $form.data('remind-path') || 'https://signup.freshteam.com/find_domain?user_email=';
  const redirect = $form.attr('data-redirect');
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(userEmail, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (!SiteUtilities.GDPRFunctionalCookieDisabled()) {
    // Binding maxmind_session
    sessionObj.location = geoLocation;
  }
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  const data = {
    signup: {
      user_email: userEmail,
      user_first_name: userFirstName,
      user_last_name: userLastName,
      user_company: userCompany,
      user_phone: userPhoneNo,
      validate_duplicate: true,
      time_zone: sessionObj.time.tz_offset
    },
    gdpr_first_opt_in: ($form.find('input[name="send_promotions"]').is(':checked')),
    country,
    session_json: sessionObj,
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || SiteUtilities.getCurrentLocation()),
    first_landing_url: Cookie.get('fw_flu') || '',
    pre_visits: Cookie.get('fw_vi') || 0,
    source: `${SiteUtilities.getParameterByName('utm_source')}`,
    medium: `${SiteUtilities.getParameterByName('utm_medium')}`,
    campaign: `${SiteUtilities.getParameterByName('utm_campaign')}`,
    fs_cookie: freshsales.anonymous_id || 'Not found'
  };

  if (sessionObj.current_session.referrer === '' && data.source === '') {
    data.source = 'Direct';
  } else if (sessionObj.current_session.referrer !== '' && data.source === '') {
    data.source = sessionObj.current_session.referrer;
  }

  const forceSignupData = {
    signup: {
      user_email: userEmail,
      user_first_name: userFirstName,
      user_last_name: userLastName,
      user_company: userCompany,
      user_phone: userPhoneNo,
      validate_duplicate: false,
      time_zone: sessionObj.time.tz_offset
    },
    gdpr_first_opt_in: ($form.find('input[name="send_promotions"]').is(':checked')),
    country,
    session_json: sessionObj,
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || SiteUtilities.getCurrentLocation()),
    first_landing_url: Cookie.get('fw_flu') || '',
    pre_visits: Cookie.get('fw_vi') || 0
  };

  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: JSON.stringify(data),
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    success: (response) => {
      if (response.success && response.url) {
        response.composite_stitching_key = compositeKey;
        fteamSignupFormSuccess($form, response);
      }
    },
    error: (xhr, status, err) => {
      if (xhr.responseText.includes('multiple_signup_detected')) {
        $('.login-trigger-button.fteam').trigger('click');
        $form.find('.button').removeClass('button--loading').removeAttr('disabled');
        $('.email-reminder-button').on('click', function () {
          $.ajax({
            url: remindEndPoint + encodeURIComponent(userEmail),
            type: 'GET',
            success: (response) => {
              $('.form-field-container,.thank-you-card').addClass('active');
            }
          });
        });
        $('.new-account-button').on('click', function () {
          $(this).addClass('button--loading product-specific');
          $.ajax({
            url: signUpApiUrl,
            type: 'POST',
            data: JSON.stringify(forceSignupData),
            accept: 'application/json; charset=UTF-8',
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json',
            success: (response) => {
              if (response.success && response.url) {
                localStorage.setItem('redirect_url', response.url);
                let thankYouRedirect = `${redirect}?ehash=${emailHash}`;
                if (isExternalIframeSignup) {
                  thankYouRedirect += '&post_to_partner=true';
                  if (currentReferrer) {
                    thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
                  }
                }
                window.location.href = thankYouRedirect;
              }
            }
          });
        });
      }
    },
    complete: () => {
      $form.find('.button').removeClass('button--loading').attr('disabled', null);
    }
  });
};

var fteamLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('.domain-form').val();
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  jQuery.getJSON(`https://${domain}.freshteam.com/sessions/current`, function (data) {
    if (data.accounts.length > 0) {
      $form.find('.domain-form').parents('.form-field').removeClass('error');
      window.location.href = 'https://' + domain + '.freshteam.com';
    }
  }).fail(function () {
    const errorMessage = "<em class='error'>This domain does not exist.</em>";
    $form.find('.button').removeClass('button--loading').removeAttr('disabled');
    $form.find('.domain-form').parents('.form-field').addClass('error').find('.error-wrapper').empty().append(errorMessage);
  });
  GA4Utilities.loginFormSubmit(domain);
};

const fteamDemoRequestForm = (className, form) => {
  const $form = $(form);
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  const firstName = $form.find('input.first-name-form').val();
  const lastName = $form.find('input.last-name-form').val();
  const email = $form.find('input.email-form').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const phone = $form.find('input.phone-form').val() || '';
  const company = $form.find('input.company-form').val();
  const geoLocation = LocationUtilities.getGeoLocation();
  // Please dont remove the ! operator below.
  // It is a critical factor in the GDPR implementation
  const isUnsubscribed = !($form.find('input[name="send_promotions"]').is(':checked'));

  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      company: company,
      phone: phone,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: !isUnsubscribed,
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };

  // enable redirect when there is no calendly form.
  setTimeout(function () {
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.location.href = $form.attr('data-redirect') + `/?ehash=${emailHash}`;
    });
  }, 300);
};

var fteamForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://signup.freshteam.com/find_domain?user_email=';
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  $.ajax({
    url: forgotDomainUrl + encodeURIComponent(email),
    type: 'GET',
    success: (response) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    },
    error: (xhr, status, err) => {
      $form.find('.button').removeClass('button--loading').removeAttr('disabled');
      $form.find('.email-form').parents('.form-field').addClass('error');
      $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
    }
  });
};

const fteamEmailMeForm = (classname, form) => {
  const $form = $(form);
  // $(form).find('button').addClass('btn-loading').attr('disabled', 'disabled');
  const email = $form.find('.email-form').val();
  let ehashParam = '';
  if (email) {
    const emailHash = SiteUtilities.getShaHash(email);
    ehashParam = `?ehash=${emailHash}`;
  }
  setTimeout(function () {
    window.location.href = $form.attr('data-redirect') + `/${ehashParam}`;
  }, 2000);
};

const fteamSignupFormSuccess = ($form, response, alohaV2 = false) => {
  const userEmail = $form.find('.email-form').val() || $form.find('.email-fteam').val();
  const userFirstName = $form.find('.first-name-form').val() || null;
  const userLastName = $form.find('.last-name-form').val() || null;
  const userCompany = $form.find('.company-form').val() || null;
  const userPhoneNo = $form.find('.phone-form').val() || null;
  const emailHash = SiteUtilities.getShaHash(userEmail);
  const redirect = $form.attr('data-redirect');
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const geoLocation = LocationUtilities.getGeoLocation();
  let redirectUrl;
  let accountId = '';
  if (alohaV2) {
    const signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : '';
  } else {
    redirectUrl = response.url;
    accountId = response.id;
  }
  SiteUtilities.configureAssetId($form, 'fteam');
  // Post to freshmarketer.
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: userFirstName,
      last_name: userLastName,
      email: userEmail,
      phone: userPhoneNo || '',
      company: userCompany,
      country: geoLocation ? geoLocation.countryName : '',
      // Please dont forget the !
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      domainUrl: redirectUrl,
      product: 'Freshteam',
      accountId: accountId,
      custom_field: {
        cf_fservicefirstreferrer: Cookie.get('fw_flu') || '',
        cf_fservicesignupreferrer: window.location.href || '',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshteam');
  SiteUtilities.freshmarketerPost(freshmarketerData, false, $form).then(function () {
    localStorage.setItem('fmarketerEndTime', new Date().toISOString());
    $('body').trigger('trackingCompleted');
  });

  $('body').on('trackingCompleted', () => {
    localStorage.setItem('redirect_url', redirectUrl);
    let thankYouRedirect = `${redirect}?account_id=${accountId}&redirect_url=${encodeURIComponent(redirectUrl)}&ehash=${emailHash}`;
    if (isExternalIframeSignup) {
      thankYouRedirect += '&post_to_partner=true';
      if (currentReferrer) {
        thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
      }
    }
    localStorage.setItem('thankyouRedirectStartTime', new Date().toISOString());
    window.location.href = thankYouRedirect;
  });
};

export default {
  fteamSignupForm,
  fteamLoginForm,
  fteamDemoRequestForm,
  fteamForgotDomainForm,
  fteamEmailMeForm,
  fteamSignupFormSuccess
};
